<div>
        <canvas baseChart
                [labels]="chartLabels"
                [datasets]="chartDatasets"
                [options]="chartOptions"
                [legend]="false"
                [type]="'doughnut'">
        </canvas>
</div>
